module.exports = __webpack_public_path__ + "static/media/nortal.bec88579.svg";